import { render, staticRenderFns } from "./UserIconContainer.vue?vue&type=template&id=156e8971&scoped=true"
import script from "./UserIconContainer.vue?vue&type=script&lang=ts"
export * from "./UserIconContainer.vue?vue&type=script&lang=ts"
import style0 from "./UserIconContainer.vue?vue&type=style&index=0&id=156e8971&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e8971",
  null
  
)

export default component.exports